<template>
  <td>
    <div>
      <v-dialog
        v-model="modal"
        persistent
        width="400px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            :loading="loading"
            small
            v-bind="attrs"
            v-on="on"
          >
            {{ lastStatus.qa_status }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Change build QA status
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="newStatus.qa_status"
              :items="qaStatuses"
              label="Status"
              dense
              outlined
              disabled
            />
            <v-textarea
              v-model="newStatus.qa_comment"
              label="Comment"
              rows="1"
              dense
              outlined
              auto-grow
              hide-details
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="close"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              :loading="saveLoading"
              @click="save"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template v-if="lastStatus.id">
        <v-tooltip bottom>
          <template v-slot:activator="tooltipActivator">
            <v-btn
              class="mx-2"
              outlined
              x-small
              fab
              v-bind="tooltipActivator.attrs"
              v-on="tooltipActivator.on"
              @click="removeLastStatus"
            >
              <v-icon small>
                {{ mdiDelete }}
              </v-icon>
            </v-btn>
          </template>
          <span>Remove last QA status</span>
        </v-tooltip>
      </template>
      <v-sheet
        v-if="lastStatus.qa_status !== 'not tested'"
        width="250"
      >
        <v-textarea
          :value="lastStatus.qa_comment"
          class="mt-2 black--text"
          rows="1"
          :hint="lastStatus.date + (lastStatus.qa ? ' | ' + lastStatus.qa : '')"
          persistent-hint
          dense
          disabled
          outlined
          auto-grow
          full-width
        />
      </v-sheet>
    </div>
  </td>
</template>

<script>
import { mdiDelete } from '@mdi/js'
export default {
  name: 'QAStatus',
  props: {
    level: {
      type: String,
      required: true
    },
    build: {
      type: Object,
      required: true
    },
    platform: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mdiDelete,
      modal: false,
      loading: true,
      saveLoading: false,
      qaStatuses: ['tested'],
      statuses: [
        {
          id: null,
          qa_status: 'not tested'
        }
      ],
      emptyStatus: {
        id: null,
        qa_status: 'not tested'
      },
      newStatus: {
        id: null,
        qa_status: 'tested',
        qa_comment: ''
      },
      defaultStatus: {
        id: null,
        qa_status: 'tested',
        qa_comment: ''
      }
    }
  },
  computed: {
    lastStatus () {
      return this.statuses[this.statuses.length - 1] || this.emptyStatus
    }
  },
  async mounted () {
    await this.loadStatuses()
  },
  methods: {
    close () {
      this.modal = false
      this.newStatus = { ...this.defaultStatus }
    },
    async loadStatuses () {
      this.loading = true
      const { data } = await this.$axios.get(`${this.$store.getters.projectPath}/builds/${this.build.id}/qa-statuses/${this.level}`)
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else if (Array.isArray(data) && data.length) {
        this.statuses = data
      }

      this.loading = false
    },
    async save () {
      this.saveLoading = true
      const { data } = await this.$axios.post(
        `${this.$store.getters.projectPath}/builds/${this.build.id}/qa-statuses/${this.level}`,
        this.newStatus
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.statuses.push(data)
      }
      this.saveLoading = false
      this.close()
    },
    async removeLastStatus () {
      if (!this.lastStatus.id) return

      const { data } = await this.$axios.delete(
        `${this.$store.getters.projectPath}/builds/${this.build.id}/qa-statuses/${this.level}/${this.lastStatus.id}`
      )
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.statuses.pop()

        if (this.statuses.length === 0) {
          this.statuses.push({ ...this.emptyStatus })
        }
      }
    }
  }
}
</script>